import { toast } from 'react-toastify';
import { Button } from '~/components/ui/Button';
import { ToastMessage } from '~/components/ui/ToastMessage';
import { redirectToPersonalBillingPage } from '~/lib/stores/pricing/helpers';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { userStore } from '~/lib/stores/user';
import { PricingPageOpenedTrigger } from '~/types/analytics';
import { redirectToOrgBillingPage } from '~/utils/subscription';

const PaymentRenewalToast = ({ showPaymentMethodButton }: { showPaymentMethodButton: boolean }) => (
  <div>
    <ToastMessage title="We couldn't renew your plan" message="Update your payment method to restore full access." />
    <div className="flex gap-2 mt-3">
      {showPaymentMethodButton && (
        <Button
          variant="secondary"
          size="sm"
          onClick={() => {
            const activeOrganization = userStore.getActiveOrganization().get();

            if (activeOrganization) {
              redirectToOrgBillingPage(activeOrganization);
            } else {
              redirectToPersonalBillingPage();
            }

            toast.dismiss();
          }}
        >
          Update payment method
        </Button>
      )}
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          pricingStore.openPricingOverlay(PricingPageOpenedTrigger.PaymentRenewalToast);
          toast.dismiss();
        }}
      >
        Review plans
      </Button>
    </div>
  </div>
);

export const showPaymentRenewalToast = (showPaymentMethodButton: boolean) => {
  toast.warning(<PaymentRenewalToast showPaymentMethodButton={showPaymentMethodButton} />, {
    autoClose: false,
    closeButton: true,
    toastId: 'payment-renewal',
  });
};
